import React, { useRef } from "react";
import "./GroupePublicationCreation.scss";
import { InputText } from "primereact/inputtext";
import { FaRegCalendarCheck, FaPaperclip } from "react-icons/fa";
import BtnBlancLeft from "Components/Boutons/BtnBlancLeft/btn-blanc-left";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import { useState } from "react";
import PropTypes from "prop-types";
import ModalCreationEvenementGroupe from "Components/Modal/ModalCreationEvenementGroupe/ModalCreationEvenementGroupe";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import { connect } from "react-redux";
import { updateGroups } from "Redux/Actions/groupsActions";
import { fetchGet } from "Services/api";
import { Toast } from "primereact/toast";
import neutralUser from "assets/neutralUser.png";

const GroupePublicationCreation = (props) => {
  const [visibleModalEvent, setVisibleModalEvent] = useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      content: "",
      availableForComments: true,
      label: "",
      sourceGroup: undefined,
    },
  });

  const [file, setFile] = useState(null);

  const uploadToast = useRef(null);
  const cancelToast = useRef(null);
  const hiddenFileRef = useRef(null);

  const updateState = async () =>
    props.handleUpdateGroups({
      publications: await fetchGet("/publications", props.auth.token),
    });

  /**
   * Fonction qui permet d'envoyer une requête post pour créer une publication
   * @param {{content: string, availableForComments: boolean, label: string, sourceGroup: string}} data données du formulaire
   */
  const postPublication = (data) => {
    let response = undefined;
    // On crée un FormData qui sera envoyé au serveur
    var formData = new FormData();
    // On ajoute les données du formulaire au formData
    for (var key in data) formData.append(key, data[key]);
    // On envoie le formData au serveur
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL_API}${"/publications/create"}`,
        formData,
        {
          headers: props.auth.token
            ? {
                accept: "application/json",
                Authorization: `Bearer ${props.auth.token}`,
              }
            : {
                accept: "application/json",
              },
        }
      )
      .then((res) => {
        response = res;
      })
      .catch((error) => {
        props.setResponse(error.response);
      })
      // Si tout s'est bien passé, on reset le formulaire
      .finally(() => {
        if (response) {
          reset();
          setFile(null);
          updateState();
          props.setResponse(response);
        }
      });
  };

  /**
   * Fonction s'occuppant de l'upload d'un fichier
   * @param {Event} event
   * @param {Object} event[].files Liste des fichiers sélectionnés
   */
  const uploadHandler = (event) => {
    const file = event.target.files[0];
    const fileReader = new FileReader();

    // Ajout évènement : dès que le fichier est chargé, on l'affiche dans le formulaire + toast succés
    fileReader.onload = () => {
      setFile(file);
      uploadToast.current.show({
        severity: "success",
        summary: "Succès : ",
        detail: "Le fichier " + file.name + " a bien été téléchargé",
        sticky: true,
      });
    };
    // Démarrage du chargement du fichier
    fileReader.readAsDataURL(file);
  };

  /**
   *  Fonction qui va remplir la propriété sourceGroup avec le groupe actuel
   * @param {{content: string, availableForComments: boolean, label: string, sourceGroup: string}} data données du formulaire
   * @returns données du formulaire avec champ sourceGroup renseigné
   */
  const assignSourceGroup = (data) => {
    data = {
      ...data,
      sourceGroup: "/api/groups/" + props.currentGroupId.toString(),
    };
    return data;
  };

  /**
   *  Fonction qui va remplir la propriété documentFile avec le fichier uploadé
   * @param {{content: string, availableForComments: boolean, documentFile: FilePrototype, label: string, sourceGroup: string}} data données du formulaire
   * @returns données du formulaire avec champ documentFile renseigné
   */
  const assignFile = (data) => {
    if (file)
      data = {
        ...data,
        documentFile: file,
      };
    return data;
  };

  const onSubmit = (data) => {
    data = assignSourceGroup(data);
    data = assignFile(data);
    postPublication(data);
  };

  /**
   * Affichage d'une erreur si nécessaire dans le formulaire
   * @param {String} name nom du champ
   * @returns {JSX.Element}
   */
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  return (
    <div>
      <ModalCreationEvenementGroupe
        visibleModalEvent={visibleModalEvent}
        currentGroupId={props.currentGroupId}
        setVisibleModalEvent={setVisibleModalEvent}
      />

      <div className="groupe_publication">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="groupe_publication__form"
        >
          <Toast ref={uploadToast} />
          <Toast ref={cancelToast} />
          <div className="groupe_publication__top">
            <h4>Écrire une publication</h4>
            {getFormErrorMessage("content")}
            <div className="groupe_publication__top__input">
              <img
                src={
                  props.currentUser.imageUrl
                    ? props.currentUser.imageUrl
                    : neutralUser
                }
                alt="Mon avatar"
                title="Mon avatar"
              />
              <Controller
                name="content"
                rules={{
                  required: "Veuillez renseigner le contenu de la publication",
                }}
                control={control}
                render={({ field }) => (
                  <InputText {...field} placeholder="Exprimez-vous..." />
                )}
              />
            </div>
          </div>
          <div className="groupe_publication__bottom">
            <div className="boutons_desktop">
              <BtnBlancLeft
                btnTexte="Proposer un événement de groupe"
                btnAction={() => setVisibleModalEvent(!visibleModalEvent)}
                action="button"
              >
                <FaRegCalendarCheck />
              </BtnBlancLeft>
            </div>
            <div className="boutons_mobile">
              <BtnBlancLeft
                btnAction={() => setVisibleModalEvent(!visibleModalEvent)}
                action="button"
              >
                <FaRegCalendarCheck />
              </BtnBlancLeft>
            </div>
            <div className="boutons_desktop">
              <>
                {file ? (
                  <>
                    <BtnBlancLeft
                      btnTexte={file.name || "Nom du fichier"}
                      action="button"
                      btnAction={() => {
                        setFile(null);
                        cancelToast.current.show({
                          severity: "error",
                          summary: "Annulation",
                          detail: "Le fichier a bien été supprimé",
                          sticky: true,
                        });
                      }}
                    >
                      <input
                        type={"file"}
                        style={{ display: "none" }}
                        onChange={uploadHandler}
                        ref={hiddenFileRef}
                      />
                      <FaPaperclip />
                    </BtnBlancLeft>
                  </>
                ) : (
                  <BtnBlancLeft
                    btnTexte="Ajouter un document"
                    action="button"
                    btnAction={() => hiddenFileRef.current.click()}
                  >
                    <input
                      type={"file"}
                      style={{ display: "none" }}
                      onChange={uploadHandler}
                      ref={hiddenFileRef}
                    />
                    <FaPaperclip />
                  </BtnBlancLeft>
                )}
              </>
            </div>
            <div className="boutons_mobile" action="button">
              <>
                {file ? (
                  <BtnBlancLeft
                    btnTexte={file.name || "Nom du fichier"}
                    action="button"
                    btnAction={() => {
                      setFile(null);
                      cancelToast.current.show({
                        severity: "error",
                        summary: "Annulation",
                        detail: "Le fichier a bien été supprimé",
                        sticky: true,
                      });
                    }}
                  >
                    <input
                      type={"file"}
                      style={{ display: "none" }}
                      onChange={uploadHandler}
                      ref={hiddenFileRef}
                    />
                    <FaPaperclip />
                  </BtnBlancLeft>
                ) : (
                  <BtnBlancLeft
                    btnTexte=""
                    action="button"
                    btnAction={() => hiddenFileRef.current.click()}
                  >
                    <input
                      type={"file"}
                      style={{ display: "none" }}
                      onChange={uploadHandler}
                      ref={hiddenFileRef}
                    />
                    <FaPaperclip />
                  </BtnBlancLeft>
                )}
              </>
            </div>

            <BtnBleu btnTexte="Publier" />
          </div>
        </form>
      </div>
    </div>
  );
};

GroupePublicationCreation.propTypes = {
  groups: PropTypes.object,
  handleUpdateGroups: PropTypes.func,
  setResponse: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  currentGroupId: PropTypes.number.isRequired,
  auth: PropTypes.object,
};

const mapStateToProps = (state) => ({
  groups: state.groups,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateGroups: (value) => {
    dispatch(updateGroups(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupePublicationCreation);
